import { api } from '../api/client';

import { API_ITEMS_URL } from '../utils';

/**
 * COPY TO… (KPR-1024; keepr-api docs/SCHEMA.md § Copies). A person copies a
 * record they can read into one of their own collections whose card matches,
 * and the copy may STAND IN for its original in a combined list.
 *
 *   getCopyTargets(itemId)   GET  /api/items/{id}/copy-targets
 *     → { targets: [{ collection, card, missing: [{ name, label, reason, group? }],
 *                      files: { copied, notCopied } }], more? }
 *   copyItem(itemId, { collection, card?, standIn })
 *                            POST /api/items/{id}/copy
 *     → { item, missing, dropped: [{ name, label, code }], files }
 *   setStandIn(itemId, standIn)
 *                            PUT  /api/items/{id}/stand-in → the copy
 *
 * The API decides everything (who may copy, into where, what lines up); these
 * only carry the request.
 */
export async function getCopyTargets(itemId) {
	const { data } = await api.get(`${API_ITEMS_URL}/${itemId}/copy-targets`);
	return data;
}

export async function copyItem(itemId, { collection, card = null, standIn = true }) {
	const body = { collection, standIn };
	if (card) body.card = card;
	const { data } = await api.post(`${API_ITEMS_URL}/${itemId}/copy`, body);
	return data;
}

export async function setStandIn(itemId, standIn) {
	const { data } = await api.put(`${API_ITEMS_URL}/${itemId}/stand-in`, { standIn });
	return data;
}

/** One item as GET serves it — the read that says whether its original can be opened. */
export async function getItemForCopy(itemId) {
	const { data } = await api.get(`${API_ITEMS_URL}/${itemId}`);
	return data;
}

/** Why an element is not copied, in the product's words (keepr-api `missing[].reason`). */
export const MISSING_REASON = Object.freeze({
	absent: 'not on this card',
	type: 'a different kind of field here',
	restricted: 'kept private where it is',
	account: 'it links the record to a person\'s account',
});

/** A refusal's sentence: the API's own words when it gave them. */
export function copyRefusal(error, fallback = 'The record could not be copied. Try again.') {
	const data = error?.response?.data;
	if (data && typeof data.message === 'string' && data.message && error.response.status < 500) return data.message;
	return fallback;
}
